export default __webpack_public_path__ + "static/media/scan_icon.35cf32a1.svg";